var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInactiveFilterIcon = function SvgInactiveFilterIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9778 11.3335H21.0323L15.995 17.6335L10.9778 11.3335ZM8.21276 10.9435C10.2438 13.5335 13.9941 18.3335 13.9941 18.3335V24.3335C13.9941 24.8835 14.4466 25.3335 14.9996 25.3335H17.0105C17.5635 25.3335 18.0159 24.8835 18.0159 24.3335V18.3335C18.0159 18.3335 21.7562 13.5335 23.7872 10.9435C24.3 10.2835 23.8275 9.3335 22.9929 9.3335H9.00707C8.17254 9.3335 7.69998 10.2835 8.21276 10.9435Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInactiveFilterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "inactive-filter-icon.ab4832c6aff0ff314886d89e15b7e270.svg";